export default class ContractModel {
    idContrato: number | null;
    idAssociado: number | null;
    empresa: string | null;
    cnpj: string | null;
    nomeFantasia: string | null;
    numeroContrato: number | null;
    planos: Plano[];
    unidade: string | null;
    
    constructor(
        idContrato: number | null,
        idAssociado: number | null,
        empresa: string | null,
        cnpj: string | null,
        nomeFantasia: string | null,
        numeroContrato: number | null,
        planos: Plano[],
        unidade: string | null,
    ) {
        this.idContrato = idContrato;
        this.idAssociado = idAssociado;
        this.empresa = empresa;
        this.cnpj = cnpj;
        this.nomeFantasia = nomeFantasia;
        this.numeroContrato = numeroContrato;
        this.planos = planos;
        this.unidade = unidade;
    }

    static fromApiResponse(data: any): ContractModel {
        return new ContractModel(
            data.id_contrato || null,
            data.id_associado || null,
            data.empresa || null,
            data.cnpj || null,
            data.nome_fantasia || null,
            data.numero_contrato || null,
            (data.planos || []).map((plano: any) => Plano.fromApiResponse(plano)),
            data.unidade || null,
        );
    }
}

class Plano {
    idContratoCategoria: number | null;
    valor: string | null;
    idCategoria: string | null;
    idContrato: number | null;
    categoria: string | null;

    constructor(
        idContratoCategoria: number | null,
        valor: string | null,
        idCategoria: string | null,
        idContrato: number | null,
        categoria: string | null
    ) {
        this.idContratoCategoria = idContratoCategoria;
        this.valor = valor;
        this.idCategoria = idCategoria;
        this.idContrato = idContrato;
        this.categoria = categoria;
    }

    static fromApiResponse(data: any): Plano {
        return new Plano(
            data.id_contrato_categoria || null,
            data.valor || null,
            data.ID_CATEGORIA || null,
            data.id_contrato || null,
            data.cad_categoria?.categoria || null
        );
    }
}